import { Icon, Tag } from "@blueprintjs/core"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import React from "react"
import classNames from "utils/classNames"
import useRouteStore from "../../routes.store"

type OutletInfoCardType = {
  outlet?: any
  isSelectable?: boolean
  sequence?: number
  disabled?: boolean
}
const OutletInfoCard = ({
  outlet,
  isSelectable,
  sequence,
}: OutletInfoCardType) => {
  const toggleSelect = useRouteStore(store => store.toggleOutletSelect)

  const isSelected = outlet?.sequence ? true : false
  const sequenceNo = sequence ? sequence : outlet?.sequence
  const sequenceElement = sequenceNo && (
    <span className="ml-2">#{sequenceNo}</span>
  )

  return (
    <>
      <div
        onClick={isSelectable ? () => toggleSelect(outlet) : undefined}
        className={classNames(
          "p-2 flex justify-between items-center text-sm text-gray-700",
          isSelectable && "hover:opacity-80 cursor-pointer",
          isSelected ? "bg-green-50" : "bg-blue-100"
        )}
      >
        {outlet.fullName}
        {isSelectable ? (
          <CustomCheckbox
            className="mb-0"
            checked={isSelected}
            onChange={() => toggleSelect(outlet)}
          />
        ) : (
          sequenceElement
        )}
      </div>
      <div className="bg-white p-2 pr-3 text-gray-700 text-sm">
        <div className="flex justify-between items-start gap-3 mb-2">
          <span className="max-w-[18rem]">
            {outlet?.address?.address || "---"}
          </span>
          <span
            className={classNames(
              "font-500 flex items-center",
              outlet?.status === "AV" ? "text-green" : "text-red-300"
            )}
          >
            <Icon icon="dot" size={16} /> {outlet?.status}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span>
            <Icon size={12} className="mr-1" icon="phone" />
            {outlet?.number}
          </span>
          {isSelectable ? sequenceElement : <span />}
        </div>
        {outlet.routepoints?.length ? (
          <div className="flex items-start gap-2 mt-2 max-w-xs">
            <span className="min-w-max">prev :</span>
            {outlet.routepoints.map(point => (
              <Tag minimal>{point.route.name}</Tag>
            ))}
          </div>
        ) : null}
      </div>
    </>
  )
}

export default OutletInfoCard
